<script>
export const group = 'Full'
</script>

<script setup>
import { frames } from '../../../utils/frames'
import InformationSurface from './shared/InformationSurface.vue'
import Reveal from './shared/Reveal.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const panelElement = ref(null)
const titleElement = ref(null)
const bodyElement = ref(null)
const accentElement = ref(null)
const imageElement = ref(null)

onMounted(() => {
  const timeline = gsapTimeline({ name: 'InformationScreenContentItem', delay: frames(10, 50) })
    .from(panelElement, { y: 36, scale: 0.98, opacity: 0, duration: frames(26, 50), ease: 'power3.out' })
    .from(titleElement, { y: 56, opacity: 0, duration: frames(20, 50), ease: 'power3.out' }, `<${frames(3, 50)}`)
    .from(bodyElement, { y: 42, opacity: 0, duration: frames(18, 50), ease: 'power2.out' }, `<${frames(5, 50)}`)
    .from(accentElement, { y: 24, scaleX: 0.85, opacity: 0, duration: frames(14, 50), ease: 'power2.out' }, `<${frames(4, 50)}`)

  if (imageElement.value) {
    timeline.from(imageElement, { scale: 1.06, y: 24, opacity: 0, duration: frames(28, 50), ease: 'power3.out' }, frames(8, 50))
  }
})
</script>

<template>
  <Reveal>
    <InformationSurface>
      <div ref="panelElement" class="flex size-full flex-col pr-24">
        <div class="flex min-h-0 flex-1 flex-col justify-between">
          <div class="flex h-full flex-col">
            <div class="relative">
              <h1 ref="titleElement" class="font-cervo text-7xl leading-[0.92] tracking-[-0.03em] text-white font-bold relative z-10">
                {{ item.properties.title }}
              </h1>
              <div class="absolute -right-12 top-6 h-10 w-10 rounded-full bg-joe-cr-blue-primary/60" />
            </div>
            <div ref="bodyElement" class="mt-10 whitespace-pre-wrap font-qarla normal-case text-4xl leading-[1.22] text-white/85 line-clamp-[12]">
              {{ item.properties.body }}
            </div>

            <div ref="accentElement" class="mt-auto pt-12 flex items-center gap-5">
              <div class="h-8 w-8 rounded-full bg-gradient-to-br from-q-cr-red-primary to-q-cr-red-primary/80" />
              <div class="h-3 w-32 rounded-full bg-q-cr-red-primary/60" />
              <div class="h-8 w-8 rounded-full bg-gradient-to-br from-joe-cr-blue-primary to-joe-cr-blue-primary/80" />
              <div class="h-3 w-40 rounded-full bg-joe-cr-blue-primary/60" />
            </div>
          </div>
        </div>
      </div>

      <template #side>
        <div class="flex h-full items-stretch">
          <div class="relative flex-1 overflow-hidden rounded-[3rem] border-3 border-q-cr-red-primary/70 bg-[linear-gradient(135deg,rgba(237,54,36,0.3)_0%,rgba(237,54,36,0.15)_100%)]">
            <img v-if="item.properties.image" ref="imageElement" :src="item.properties.image" class="size-full object-cover" />
            <div v-else ref="imageElement" class="absolute inset-0 overflow-hidden bg-[linear-gradient(160deg,rgba(237,54,36,0.35),rgba(80,80,120,0.2)_35%,rgba(30,100,200,0.35)_100%)]">
              <div class="absolute left-0 top-0 h-64 w-64 rounded-full bg-q-cr-red-primary/60 blur-3xl -translate-x-1/3 -translate-y-1/3" />
              <div class="absolute right-0 bottom-0 h-80 w-80 rounded-full bg-joe-cr-blue-primary/50 blur-3xl translate-x-1/4 translate-y-1/4" />
              <div class="absolute left-10 top-1/3 h-20 w-20 rounded-full blur bg-q-cr-red-primary/50" />
              <div class="absolute right-1/4 bottom-1/4 h-24 w-24 rounded-full blur bg-joe-cr-blue-primary/30" />
            </div>
          </div>
        </div>
      </template>
    </InformationSurface>
  </Reveal>
</template>
